import React from 'react';
import styles from './styles';
import {fetchTerms, removeTerms} from '../../Hooks/fetchers';
import {colors} from '@xpertdox_js/xdstyle';
import {Button, Icons, Loader, ModalContainer} from "@xpertdox_js/xdcomponents";
import RequestForm from "../../../Common/RequestForm";
import CommonTerms from "../../../Common/CommonTerms";

const Conditions = (props) => {
  const [terms, setTerms] = React.useState(null);
  const [loading, setLoading] = React.useState(false);
  const [showModal, setShowModal] = React.useState(false);
  const [modalTerm, setModalTerm] = React.useState(false);
  const callControl = React.useRef({
    fetched: false,
    loading: false
  });
  const [bulkAction, setBulkAction] = React.useState(false)

  const callTerms = () => {
    callControl.current.fetched = true;
    callControl.current.loading = true;
    fetchTerms(props.nct, props.email, props.instance).then(result => {
      callControl.current.loading = false;
      setLoading(false)
      if(result.data[0] && result.data[0].terms) setTerms(result.data[0].terms)
    }).catch(err => console.log(err))
  }

  if(!terms && !callControl.current.fetched) callTerms()

  const remove = (term) => {
    callControl.current.loading = true;
    setLoading(true)
    removeTerms(props.nct, term, props.instance, props.email).then(() => callTerms()).catch(err => console.log(err))
  }

  const toggleModal = (term) => {
    setShowModal(true);
    setModalTerm(term);
  }

  const bulkButton = (type) => {
    if(type === bulkAction) {
      setBulkAction(false)
      setTerms(false)
      callControl.current.fetched = false
    }
    else {
      let newTerms = []
      if(type === 'Enable All') terms.forEach(term => newTerms.push({...term, excluded: false}))
      else terms.forEach(term => newTerms.push({...term, excluded: true}))
      setBulkAction(type);
      // setTerms(newTerms)
      removeTerms(props.nct, null, props.instance, props.email, {bulkAction: type,terms: newTerms}).then(() => {
        callTerms()
        setBulkAction(false)
      }).catch(err => console.log(err))
    }
  }

  const btnEnabled = {
    'Enable All': terms ? terms.every(a => !a.excluded) : false,
    'Disable All': terms ? terms.every(a => a.excluded) : false
  }

  return <div style={{...styles.container, paddingTop: 10 }}>
    <h2>Mapped Conditions</h2>
    <div style={styles.nct}>
      {(terms && !callControl.current.loading) && <React.Fragment>
        <div style={styles.bulkBtns}>{['Enable All', 'Disable All'].map((type, i) => <Button key={i} styles={{
          ...styles.bulkBtn,
          opacity: btnEnabled[type] ? .8 : 1,
          cursor: btnEnabled[type] ? 'not-allowed' : 'pointer'
        }} onClick={() => btnEnabled[type] ? null : bulkButton(type)}>{type}</Button>)}</div>
        {terms.map((term, index) => {
          let btnStyles = styles.nctContainer
          if(term.excluded) btnStyles = {
            ...btnStyles,
            ...styles.excluded
          }
          return <div key={index}>
            <Button
              id={`nct_${index}`}
              onClick={() => remove(term)}
              styles={btnStyles}
              hoverStyles={styles.nctHover}
            >
              <span>{term.name1}</span>
              <Icons icon={!term.excluded ? 'check': 'circle'} style={{...styles.icon, transform: 'translate(7px, -0.5px)'}} />
            </Button>
            <div style={styles.subText} onClick={() => toggleModal(term)}>
              <Icons icon='infoSolid' style={styles.subIcon}/>
              <p style={{margin: '0px 3px', fontSize: 13}}>Related terms</p>
            </div>

          </div>
        })}
      </React.Fragment>}
      {(callControl.current.loading || loading) && <div style={{width: '100%', height: 150}}><Loader /></div>}
    </div>
    {/*{bulkAction && <div style={styles.bulkBtns}><Button styles={{...styles.bulkBtn, backgroundColor: colors.success}} onClick={saveBulk}>Save Bulk Action</Button></div>}*/}
    <RequestForm
      {...props}
      styles={styles}
      activeTerms={terms}
      conditions
      nct={props.nct}
      instance={props.instance}
      email={props.email}
    />
    <ModalContainer
      wrapStyles={styles.wrapStyle}
      open={showModal}
      width={400}
      close={() => setShowModal(false)}
      showOverlay={showModal}
    >
      <CommonTerms term={modalTerm}/>
    </ModalContainer>
  </div>
}

export default Conditions;
